import { ColumnConfig } from "@/components/table-builder";
import { DemonstrativoExtratoBancarioRow } from "../demonstrativo-extrato-bancario.types";

export const DEMONSTRATIVO_EXTRATO_BANCARIO_TABS = [
  "Todos",
  "Entradas",
  "Saídas",
  "Incentivos",
] as const;

export const demonstrativoExtratoBancarioColumns: ColumnConfig<DemonstrativoExtratoBancarioRow>[] = [
  { key: "dataPagamento", label: "Data do Pagamento" },
  { key: "historico", label: "Histórico" },
  { key: "fomentoDepositos", label: "Fomento Depósitos" }, // money +
  { key: "outrosDepositos", label: "Outros Depósitos" }, // money +
  { key: "transferenciasRecConc", label: "Transferências Rec/Conc" }, // money + e -
  { key: "aplicacoesResgates", label: "Aplicações/Resgates" }, // money + e -
  { key: "pagamentos", label: "Pagamentos" }, // money -
  { key: "despesasBancarias", label: "Despesas Bancárias" }, // money -
  { key: "banco", label: "Banco" },
  { key: "credor", label: "Credor" },
  { key: "valor", label: "Valor" }
]
